<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-row>
                <b-col md="4">
                    <strong>Jenis Barang :</strong>

                    <multiselect v-model="selectedItemKind" label="name" track-by="id" :internal-search="true"
                        :options="optItemKind" @input="onChangeItemKind" />
                </b-col>
            </b-row>
            <b-card class="mt-3">
                <h5 class="mb-0">{{ selectedItemKind ? selectedItemKind.name : "-" }}</h5>
                <hr />
                <b-row class="mb-3">
                    <b-col md="6">
                        <div class="small text-muted" v-if="lastUpdated.at && lastUpdated.by">
                            Perubahan terakhir pada {{ $helper.parseDate(lastUpdated.at) }}<br />
                            oleh {{ lastUpdated.by }}
                        </div>
                    </b-col>
                    <b-col md="6" class="text-right" v-if="mode === 1">
                        <b-button variant="dark" @click="addRow(-1)">
                            <i class="fa fa-plus mr-2"></i> Tambah Baris Paling Atas
                        </b-button>
                    </b-col>
                </b-row>
                <!-- Mode 1: Tabel untuk selain dari HP, TABLET JAM TANGAN -->
                <div v-if="mode === 1" class="mb-3">
                    <b-table responsive bordered no-local-sorting :fields="fields" :items="items"
                        @sort-changed="onSortChanged">
                        <template v-slot:cell(from)="row">
                            <b-form-input v-model="row.item.from" class="text-right"
                                @input="sanitize(row.item, 'from')"></b-form-input>
                        </template>
                        <template v-slot:cell(to)="row">
                            <b-form-input v-model="row.item.to" class="text-right"
                                @input="sanitize(row.item, 'to')"></b-form-input>
                        </template>
                        <template v-slot:cell(batangan)="row">
                            <b-form-input v-model="row.item.batangan" class="text-right"
                                @input="sanitize(row.item, 'batangan')"></b-form-input>
                        </template>
                        <template v-slot:cell(action)="row">
                            <div style="width: 80px; margin-top: 2px">
                                <b-button size="sm" variant="primary" class="mr-2" v-b-tooltip.hover title="Tambah"
                                    @click="addRow(row.index)">
                                    <i class="fa fa-plus"></i>
                                </b-button>
                                <b-button size="sm" variant="danger" v-b-tooltip.hover title="Hapus"
                                    @click="deleteRow(row.index)">
                                    <i class="fa fa-times"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <!-- Mode 2: Untuk Jenis Barang: HP, TABLET JAM TANGAN -->
                <div v-else class="mt-4">
                    <b-row>
                        <b-col md="6">
                            <h6>Persentase Harga {{ selectedItemKind ? selectedItemKind.name : "-" }}</h6>
                        </b-col>
                        <b-col md="4">
                            <b-input-group append="%">
                                <b-form-input v-model="inputPercentage" class="text-right"
                                    @input="sanitizeInputPercentage"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="2">
                            <b-button variant="primary" @click="execSave" :disabled="isSubmitting">
                                {{ isSubmitting ? "Updating..." : "Update Harga" }}
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div class="text-right mt-3" v-if="mode === 1">
                    <b-button variant="success" @click="confirmSave">
                        Simpan Perubahan
                    </b-button>
                </div>
            </b-card>
        </div>
        <b-modal id="m-confirm" title="Simpan Perubahan" no-close-on-backdrop no-close-on-esc hide-footer>
            Simpan rumus umum perubahan harga batangan untuk jenis barang <strong>{{ selectedItemKind ?
                selectedItemKind.name : "-" }}</strong>?
            <div class="small text-muted">Harga 'sampai' terakhir akan otomatis diubah menjadi 99 miliar ketika disimpan.
            </div>
            <div class="text-right mt-4">
                <b-button variant="primary" @click="execSave" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'batangan-price-adjustment',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            fields: [
                { key: "from", label: "Dari", sortable: true },
                { key: "to", label: "Sampai", sortable: true },
                { key: "batangan", label: "Batangan", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            inputs: ["from", "to", "batangan"],
            inputPercentage: "",

            items: [],

            lastUpdated: { at: "", by: "" },

            sortBy: null,
            sortDesc: false,

            optItemKind: [],
            selectedItemKind: null

        }
    },
    computed: {
        mode() {
            if (!this.selectedItemKind) return 1;
            // Mode 2 untuk Handphone (1), Tablet (3), Jam Tangan (9)
            const specialKinds = [1, 3, 9];
            return specialKinds.includes(this.selectedItemKind.id) ? 2 : 1;
        }
    },
    methods: {

        init() {

            this.initStatus = 0

            let getItemKinds = this.$axios.get("master/kinds").then(res => {
                this.optItemKind = res.data.data.map(it => {
                    return { id: it.id, name: it.name }
                })
                this.selectedItemKind = this.optItemKind[0]
            })

            Promise.all([getItemKinds]).then(() => {
                this.getItems()
            })
                .catch(_ => {
                    this.initStatus = -1
                })

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        onChangeItemKind() {
            this.initStatus = 0
            this.getItems()
        },

        getItems() {
            let param = ""
            param += "?itemKindId=" + this.selectedItemKind.id
            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            return this.$axios.get("/master/batangan-price-adjustment" + param).then(res => {

                let data = res.data.data.data

                if (this.mode === 2) {
                    this.inputPercentage = String(data.percentage);
                    this.lastUpdated.at = data.lastUpdatedAt
                    this.lastUpdated.by = data.lastUpdatedBy
                } else {
                    this.items = data.entries
                    this.lastUpdated.at = data.lastUpdatedAt
                    this.lastUpdated.by = data.lastUpdatedBy
                    this.sanitizeAll()
                }

                this.initStatus = 1

            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })
        },

        confirmSave() {
            if (this.mode !== 1) return;

            if (this.items[0].from != "0") {
                return this.$helper.toastError(this, "Baris pertama harus dimulai dengan dari Rp 0!")
            }

            for (var i = 0; i < this.items.length; i++) {
                for (var j = 0; j < this.inputs.length; j++) {
                    if (this.items[i][this.inputs[j]] == "") {
                        return this.$helper.toastError(this, "Terdapat kotak yang kosong, mohon cek kembali!")
                    }
                }
            }

            this.$bvModal.show("m-confirm")
        },

        execSave() {

            if (this.mode === 2) {
                if (this.inputPercentage === 0 || this.inputPercentage === "") {
                    return this.$helper.toastError(this, "Persentase tidak boleh kosong atau 0!");
                }
            }

            let payload = {
                itemKindId: this.selectedItemKind.id
            }

            if (this.mode === 1) {
                let entries = []
                this.items.forEach(it => {
                    entries.push({
                        from: this.$helper.toNumber(it.from),
                        to: this.$helper.toNumber(it.to),
                        batangan: this.$helper.toNumber(it.batangan)
                    })
                })
                payload.entries = entries
            } else {
                payload.percentage = this.inputPercentage;
            }

            this.isSubmitting = true
            this.$axios.post("/master/batangan-price-adjustment", payload).then(res => {

                let data = res.data.data

                this.lastUpdated.at = data.at || data.lastUpdatedAt
                this.lastUpdated.by = data.by || data.lastUpdatedBy

                if (this.mode === 1) {
                    this.items[this.items.length - 1].to = "99.999.999.999"
                    this.$bvModal.hide("m-confirm")
                    this.$helper.toastSuccess(this, "Rumus umum perubahan harga batangan untuk jenis barang " + (this.selectedItemKind ? this.selectedItemKind.name : "-") + " berhasil disimpan!")
                } else {
                    this.$helper.toastSuccess(this, `Persentase untuk ${this.selectedItemKind.name} berhasil diupdate!`);
                }


            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        addRow(index) {
            this.items.splice(index + 1, 0, { from: "", to: "", batangan: "" })
        },

        deleteRow(index) {
            this.items.splice(index, 1)
        },

        sanitizeInputPercentage() {
            let cleaned = String(this.inputPercentage).replace(
                /(?!^-)[^0-9.]/g,
                ""
            );

            this.inputPercentage = cleaned;
        },

        sanitize(item, varName) {

            let cleaned = String(item[varName]).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item[varName] = res

        },

        sanitizeAll() {

            this.items.forEach(it => {
                this.inputs.forEach(v => this.sanitize(it, v))
            })

        }

    },

    created() {
        this.init()
    }
}
</script>
